import { render } from "./elecBoardHeat.vue?vue&type=template&id=cd71594c"
import script from "./elecBoardHeat.vue?vue&type=script&lang=js"
export * from "./elecBoardHeat.vue?vue&type=script&lang=js"

import "./elecBoardHeat.vue?vue&type=style&index=0&id=cd71594c&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__